import { render, staticRenderFns } from "./PlanSettingsTags.vue?vue&type=template&id=066e5643"
import script from "./PlanSettingsTags.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsTags.vue?vue&type=script&lang=ts"
import style0 from "./PlanSettingsTags.vue?vue&type=style&index=0&id=066e5643&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports